var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"event"}},[_c('div',{staticClass:"events"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.event.name + " " + _vm.event.edition))])]),_c('div',{staticClass:"welcome_msg"},[(
          'volunteers.welcome_msg.' + _vm.formatUrl(_vm.event.name, _vm.event.edition) !=
            _vm.$t(
              'volunteers.welcome_msg.' + _vm.formatUrl(_vm.event.name, _vm.event.edition)
            )
        )?_c('span',{domProps:{"innerHTML":_vm._s(
          _vm.$t('volunteers.welcome_msg.' + _vm.formatUrl(_vm.event.name, _vm.event.edition))
        )}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }